import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from 'lib/firebase/firebase';
import { UserType } from '../types';

export const getUser = async (): Promise<UserType> => {
  if (!auth.currentUser) return null;

  const userRef = doc(db, 'users', auth.currentUser.uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) return null;

  return userSnap.data() as NonNullable<UserType>;
};
